import type EmberStore from "cc-frontend/services/ember-store"
import { useCallback } from "react"
import { useEmberService } from "react-app/providers/ember-service-context"

/**
 * Returns a converter from a supergrain document to the Ember store's copy of it, looked up by id.
 * The legacy Ember modals — anything rendered through `modalManager.openModal` — want that copy.
 */
export function useAsEmberDocument() {
  const emberStore = useEmberService<EmberStore>("ember-store")

  return useCallback(
    <T extends { type: string; id: string }>(doc: T): T =>
      emberStore.findInMemory(doc.type, doc.id),
    [emberStore],
  )
}
